<template>
  <b-card no-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(title)="data">
        <div v-if="data.item.scode">
          <small class="text-warning">{{ data.item.scode }}</small>
        </div>
        {{ data.item.title }}
        <div v-if="data.item.stock_groups">
          <small class="text-primary">{{ data.item.stock_groups }}</small>
        </div>
      </template>
      <template #cell(amount)="data">
        {{ data.item.amount | toNumber }} {{ data.item.units }}
      </template>
    </b-table>
    <b-card-footer>
      <b-row>
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
        <b-col md="auto">
          <div
            v-if="dataList.length >0"
            class="text-right"
          >
            <small class="text-muted">Toplam</small>
            <h3>{{ amountTotal | toCurrency }} <span class="text-primary">{{ dataList[0].units }}</span></h3>
          </div>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BPagination, BCardFooter, BRow, BCol,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'purchase_offer_items'
export default {
  name: 'PurchaseOfferItemsTable',
  components: {
    BCard,
    BTable,
    BPagination,
    BCardFooter,
    BRow,
    BCol,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      fields: [
        {
          key: 'title',
          label: 'Stok Kartı',
        },
        {
          key: 'amount',
          label: 'Miktar',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.amount AS amount`,
          'stocks.title AS title',
          'stocks.scode AS scode',
          'units.title AS units',
          'stock_groups.title AS stock_groups',
        ],
        where: {
          'purchase_offer_items.id_purchase_offers': this.$route.params.id,
        },
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['purchaseOfferItems/dataList']
    },
    dataItem() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
    dataCounts() {
      return this.$store.getters['purchaseOfferItems/dataCounts']
    },
    saveData() {
      return this.$store.getters['purchaseOfferItems/dataSaveStatus']
    },
    amountTotal() {
      return this.dataList.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * 25
      this.getDataList()
    },
  },
  created() {
    //    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('purchaseOfferItems/getDataList', this.dataQuery)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
